import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { formatDuration } from 'components/Duration';
/**
 * The transcript as plain text, to paste into a chat assistant: the meeting's title, then one
 * "[m:ss] Speaker: text" paragraph per turn, without the times when the transcript has none
 * @param options - Options
 * @param options.meetingTitle - The meeting's title
 * @param options.transcript - The speaker turns
 * @param options.hasTimings - Whether the transcript has timings
 * @param options.unknownSpeakerLabel - What to call a speaker the transcript doesn't name
 * @returns The text
 */
export default function getTranscriptCopyText(_ref) {
  var meetingTitle = _ref.meetingTitle,
    transcript = _ref.transcript,
    hasTimings = _ref.hasTimings,
    unknownSpeakerLabel = _ref.unknownSpeakerLabel;
  var turns = transcript.map(function (_ref2) {
    var speaker = _ref2.speaker,
      text = _ref2.text,
      startTime = _ref2.startTime;
    var time = hasTimings ? "[".concat(formatDuration(startTime), "] ") : '';
    return "".concat(time).concat(speaker !== null && speaker !== void 0 ? speaker : unknownSpeakerLabel, ": ").concat(text);
  });
  return [meetingTitle].concat(_toConsumableArray(turns)).filter(Boolean).join('\n\n');
}